export default __webpack_public_path__ + "static/media/redux.73908514.svg";